// extracted by mini-css-extract-plugin
export default {"HeroCopy":"Loader_HeroCopy__WuImv","Loader":"Loader_Loader__tsvKu","rotate":"Loader_rotate__6U8gn","prixClipFix":"Loader_prixClipFix__A1ULv","Dark":"Loader_Dark__hDbYf"};